import { render, staticRenderFns } from "./vMoneyInput.vue?vue&type=template&id=637bb8ba&scoped=true"
import script from "./vMoneyInput.vue?vue&type=script&lang=js"
export * from "./vMoneyInput.vue?vue&type=script&lang=js"
import style0 from "./vMoneyInput.vue?vue&type=style&index=0&id=637bb8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637bb8ba",
  null
  
)

export default component.exports